import script from "./BackToTop.vue?vue&type=script&setup=true&lang=js"
export * from "./BackToTop.vue?vue&type=script&setup=true&lang=js"

import "./BackToTop.vue?vue&type=style&index=0&id=65f718d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f718d7"]])

export default __exports__